import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  salasList:[],
  horasList:[],
  minutosList:[],
  newData:[],
  citasList:[],
};
export const mutations = {
  GET_HORAS({ context }, horasList) {
    state.loading = false;
    if (horasList) {
      let horas = [];
      Object.entries(horasList).forEach(([key, val]) => horas.push(val));
      return (state.horasList = horas);
    }
    //state.horasList = horasList;
  },

  GET_MINUTOS({ context }, minutosList) {
    state.loading = false;
    if (minutosList) {
      let minutos = [];
      Object.entries(minutosList).forEach(([key, val]) => minutos.push(val));
      return (state.minutosList = minutos);
    }
    //state.horasList = horasList;
  },

  GET_SALAS({ context }, salasList) {
    state.salasList = salasList.data.salas;
  },
  AGENDAR_NUEVO({ context }, data) {
    state.newData = Object.assign({}, data);
  },
  GET_CITAS({ context }, citasList) {
    state.loading = false;
    if (citasList) {
      let citas = [];
      Object.entries(citasList).forEach(([key, val]) => citas.push(val));
      //console.log(agendas);
      return (state.citasList = citas);
    }
  },
  EDITAR_CITAS({ context }, dataCita) {
    state.dataCita = Object.assign({}, dataCita);
  },
  DELETE_CITA({ context }, deleteCita) {
    state.deleteCita = Object.assign({}, deleteCita);
  },
};
export const actions = {

  GET_HORAS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_HORAS", response.data.data.list_horas);//mandar a mutations
          //console.log(response.data.data);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_MINUTOS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_MINUTOS", response.data.data.minutos);//mandar a mutations
          //console.log(response);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_SALAS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_SALAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  AGENDAR_NUEVO({ commit },data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      //console.log(data);
      ApiService.post(data)
        .then(response => {
          // console.log(response);
          commit("SET_LOADING", false);
          commit("AGENDAR_NUEVO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  GET_CITAS({ commit },data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      // console.log(data);
      ApiService.get(data)
        .then(response => {
          // console.log(response);
          commit("SET_LOADING", false);
          commit("GET_CITAS", response.data.data.citas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  EDITAR_CITAS({ commit }, data) { //axios, mandar parametros para post
    //console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("EDITAR_CITAS", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

  DELETE_CITA({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          commit("DELETE_CITA", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {//leer datos
  salasList: state => state.salasList,
  horasList: state => state.horasList,
  minutosList: state => state.minutosList,
  citasList: state => state.citasList,
};
